import React from 'react'
import flat from "../../../img/flattube.png"
import useIsInViewport from 'use-is-in-viewport'

function Flattube() {
	const [isInViewport, targetRef] = useIsInViewport()
	var classes = `${isInViewport ? "visible" : "hidden"}`
	return ( 
		<div ref={targetRef} className={classes}>
			<div className="project"> 
				<img alt="Flattube" src={flat}/>
				<div className="info">
				<h2>FlatTube ⏯</h2>
				<div className="links">
					<a href="https://www.youtube.com/watch?v=UHLiF3zhiAo&feature=youtu.be">Demo</a> 
					<a href="https://github.com/jguzz/flattube-client">Frontend</a> 
					<a href="https://github.com/jguzz/FlatTube-Backend">Backend</a> 
				</div>

				<h4>
					A full stack web application having the same basic functionality of Youtube using live data.
				</h4>
				<p>- Created a single page front end utilizing <strong>React</strong> styled with <strong>React Bootstrap</strong>.<br/>
				- Developed a <strong>Rails API</strong> backend using <strong>MVC</strong> patterns.<br/>
				- Utilized Fetch and state to allow persistent User Created Playlists.<br/>
				- Live database seeding of videos with detailed information using <strong>YouTube Data API</strong>.</p>
				</div>
			</div>
	  	</div>
	  )
}

export default Flattube